<template> 
  <div class="policies">
    <div class="table">
      <div class="table__header box box--default">
       <div class="table__label table__label--medium"> 
            {{ $t(`pendenciesTable.${"pendencyNr"}`) }}
        </div>
        <div class="table__label table__label--medium table__label--fixed">
          {{ $t(`pendenciesTable.${"status"}`) }} 
        </div>
        <div class="table__label table__label--large">{{ $t(`pendenciesTable.${"policyNr"}`) }}</div>
        <div class="table__label table__label--large">{{ $t(`pendenciesTable.${"issuanceDate"}`) }}</div> 
        <div class="table__label table__label--large">{{ $t(`pendenciesTable.${"insurer"}`) }}</div>
        <div class="table__label table__label--large">{{ $t(`pendenciesTable.${"industry"}`) }}</div>
        <div class="table__label table__label--medium">{{ $t(`pendenciesTable.${"responsible"}`) }}</div>
        <div
          class="table__label table__label--medium table__label--more-horizontal table__label--last"
        ></div>
      </div>
      <Loading v-if="detailsLoading" />
      <div v-else class="table__body">
        <div v-if="!computedPendencies.length" class="table__no-data">
          <NoData :type="'pendencies'" />
        </div>
      
        <div v-else class="table__policies"> 
          <Pendency
            v-for="pendency in computedPendencies"
            :key="pendency.id"
            :statuses="statuses"
            :agents="agents"
            :pendency="pendency"
            :expandedPendencyId = "expandedPendencyId"
            :offer = "pendency.customerPolicyOffers"
          />
        </div>  
      </div>

      <!-- <Pagination
        :limit="3"
      :data="usersPerPage"
      @pagination-change-page="getResults"
    ></Pagination> -->
    </div>
  </div>
</template>

<script>
import Pendency from "@/components/AccountDetails/Pendency";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";
import { mapGetters } from "vuex";
export default {
  name: "PendenciesTable",

  components: {
    Pendency,
    Loading,
    NoData, 
  },

  computed: {
    ...mapGetters([
      "pendencyForms", "customerDetails"]
    ),
    computedPendencies() {
      return this.$store.getters.pendencies;
    },
    statuses() {
      return this.pendencyForms.statuses || [];
    },
    agents() {
      return this.pendencyForms.agents || [];
    },

    costumerId(){
      return this.$store.getters.customerDetailsId;
    }
  },

  watch: {
    costumerId(newId, oldId) {
      if (newId && newId !== oldId) {
        this.fetchPendencies();
      }
    },

    'customerDetails.team'(newTeam, oldTeam) {
      if (newTeam && newTeam !== oldTeam) {
        this.fetchPendencies();
      }
    }
  },

  async mounted(){
    await this.fetchPendencies();
  },

  methods: {
    async fetchPendencies() {
      if (!this.costumerId) {
        return;
      }

      if (this.lastFetchedCustomerId === this.costumerId) {
        return;
      }

      this.detailsLoading = true;
      try {
        if (this.customerDetails.team) {
          this.teamId = Number(this.customerDetails.team.id);
          await this.$store.dispatch("getPendencyForms", this.teamId);
        }
        await this.$store.dispatch("getPendencies", this.costumerId);
        this.lastFetchedCustomerId = this.costumerId;
      } catch (error) {
        console.log(error);
      } finally {
        this.detailsLoading = false;
      }
    }
  },

  data(){
    return{
      detailsLoading: false,
      pendencies:[],
      lastFetchedCustomerId: null,  
    }
  },

  props: {
    expandedPendencyId:{
      required: false,
      type: Number,
    }
  },
};
</script>
